import { SubNav } from "@/components/ui/sub-nav"

const TABS = [
  { key: "details", label: "My details", href: "/profile" },
  { key: "password", label: "Password", href: "/profile/password" },
]

export function ProfileSubNav({ active }: { active: "details" | "password" }) {
  return <SubNav items={TABS} active={active} ariaLabel="Profile sections" />
}
